import { render, staticRenderFns } from "./ConsultAppointmentsAdvancedPage.vue?vue&type=template&id=bd80d5ac"
import script from "./ConsultAppointmentsAdvancedPage.vue?vue&type=script&lang=ts"
export * from "./ConsultAppointmentsAdvancedPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultAppointmentsAdvancedPage.vue?vue&type=style&index=0&id=bd80d5ac&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports